// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  font-family: "Roboto";
  font-size: 22px;
  font-weight: normal;
}

.caixa_buscar {
  position: relative;
}

/* INPUT  */
.input_tabelaEmprestimoAluno {
  margin-top: 1.5em;
  background-color: var(--cor-roxoInput);
  border: none;
  width: 98.5%;
  height: 50px;
  border-radius: 8px;
  font-size: 1em;
}

.input_tabelaEmprestimoAluno::placeholder {
  font-family: "Roboto";
  font-weight: 400;
}

.input_tabelaEmprestimoAluno:focus {
  outline: none;
}

.input_tabelaEmprestimoAluno:hover {
  background-color: var(--cor-roxoClaro); 
}

.input_tabelaEmprestimoAluno[type="text"] {
  padding-left: 25px;
}

/* BTN PESQUISAR  */
.btn_pesquisar {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-25%);
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 80px;
}

.btn_pesquisar:hover {
  background-color: var(--cor-roxoClaro);
}

/* TABELA  */
.container_tabelaEmprestimoAluno {
  margin-top: 1.5em;
}

/* STATUS DA TABELA  */
.status_container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status_emDia {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--cor-verde);
}

.status_emAtraso {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--cor-vermelho);
}

.status_vazio{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(15, 115, 209);
}

.ENTREGUE{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(15, 115, 209);
}

.msg_dadoNaoEncontrado {
  margin-top: 5%;
  font-size: large;
  font-weight: 500;
  text-align: center;
}


`, "",{"version":3,"sources":["webpack://./src/Componets/TabelaEmprestimoAluno.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["h2 {\n  font-family: \"Roboto\";\n  font-size: 22px;\n  font-weight: normal;\n}\n\n.caixa_buscar {\n  position: relative;\n}\n\n/* INPUT  */\n.input_tabelaEmprestimoAluno {\n  margin-top: 1.5em;\n  background-color: var(--cor-roxoInput);\n  border: none;\n  width: 98.5%;\n  height: 50px;\n  border-radius: 8px;\n  font-size: 1em;\n}\n\n.input_tabelaEmprestimoAluno::placeholder {\n  font-family: \"Roboto\";\n  font-weight: 400;\n}\n\n.input_tabelaEmprestimoAluno:focus {\n  outline: none;\n}\n\n.input_tabelaEmprestimoAluno:hover {\n  background-color: var(--cor-roxoClaro); \n}\n\n.input_tabelaEmprestimoAluno[type=\"text\"] {\n  padding-left: 25px;\n}\n\n/* BTN PESQUISAR  */\n.btn_pesquisar {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-25%);\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  border-radius: 80px;\n}\n\n.btn_pesquisar:hover {\n  background-color: var(--cor-roxoClaro);\n}\n\n/* TABELA  */\n.container_tabelaEmprestimoAluno {\n  margin-top: 1.5em;\n}\n\n/* STATUS DA TABELA  */\n.status_container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status_emDia {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: var(--cor-verde);\n}\n\n.status_emAtraso {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: var(--cor-vermelho);\n}\n\n.status_vazio{\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: rgb(15, 115, 209);\n}\n\n.ENTREGUE{\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: rgb(15, 115, 209);\n}\n\n.msg_dadoNaoEncontrado {\n  margin-top: 5%;\n  font-size: large;\n  font-weight: 500;\n  text-align: center;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
